import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './MultiImageModal.scss';
import { Image } from '../utils/types';
import { CloseIcon } from '../common/CloseIcon';

type Props = {
  images: Image[];
  closeImageModal: () => void;
};

const MultiImageModal: React.FC<Props> = ({ images, closeImageModal }) => {
  // Prevent scrolling of the background content when modal is open
  useEffect(() => {
    // Save the original styles
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalHeight = document.body.style.height;
    const originalWidth = document.body.style.width;
    
    // Apply more restrictive styles to ensure the modal is on top
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'relative'; // This helps with stacking contexts
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    
    // Add a class to the html element for additional styling control
    document.documentElement.classList.add('multi-image-modal-open');
    
    // Cleanup function to restore original styles
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.height = originalHeight;
      document.body.style.width = originalWidth;
      document.documentElement.classList.remove('multi-image-modal-open');
    };
  }, []);

  // Create the modal content
  const modalContent = (
    <div className="multi-image-modal-overlay" onClick={closeImageModal}>
      <div 
        className="multi-image-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="multi-image-modal__close-wrapper">
          <button onClick={closeImageModal} className="multi-image-modal__close-button">
            <CloseIcon size={14} color="#FFFFFF" />
          </button>
        </div>
        <div className="multi-image-modal__content">
          {images.map((image, index) => (
            <div key={index} className="multi-image-modal__image-wrapper">
              <img 
                src={image.url} 
                alt={`Property ${index + 1}`}
                className="multi-image-modal__image"
                loading={index > 0 ? "lazy" : "eager"}
              />
{/*               <div className="multi-image-modal__image-counter">
                {index + 1}/{images.length}
              </div> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // Use createPortal to render the modal directly to the document body
  // This bypasses any stacking context issues in the component hierarchy
  return ReactDOM.createPortal(
    modalContent,
    document.getElementById('root') || document.body
  );
};

export default MultiImageModal; 